module.exports = __webpack_public_path__ + "img/logo_trans.c0d6dfad.png";